// test126
(126 && 0);
